var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 37,
    viewBox: "0 0 38 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8794_250319)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.32422,
    y: 2,
    width: 29.3255,
    height: 29,
    rx: 5,
    fill: "#272A3A"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 18.9C10.7761 18.9 11 19.1239 11 19.4V21.9C11 22.4523 11.4477 22.9 12 22.9H24C24.5523 22.9 25 22.4523 25 21.9V19.4C25 19.1239 25.2239 18.9 25.5 18.9C25.7761 18.9 26 19.1239 26 19.4V21.9C26 23.0046 25.1046 23.9 24 23.9H12C10.8954 23.9 10 23.0046 10 21.9V19.4C10 19.1239 10.2239 18.9 10.5 18.9Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6464 20.8536C17.8417 21.0488 18.1583 21.0488 18.3536 20.8536L21.3536 17.8536C21.5488 17.6583 21.5488 17.3417 21.3536 17.1464C21.1583 16.9512 20.8417 16.9512 20.6464 17.1464L18.5 19.2929V10.5C18.5 10.2239 18.2761 10 18 10C17.7239 10 17.5 10.2239 17.5 10.5V19.2929L15.3536 17.1464C15.1583 16.9512 14.8417 16.9512 14.6464 17.1464C14.4512 17.3417 14.4512 17.6583 14.6464 17.8536L17.6464 20.8536Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8794_250319",
    x: 0.324219,
    y: 0,
    width: 37.3257,
    height: 37,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8794_250319"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8794_250319",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackDownloadIcon);
export default __webpack_public_path__ + "static/media/black-download-icon.a122cc9d935790f1f402fb545da2ffbb.svg";
export { ForwardRef as ReactComponent };